import i18n from '@/lang'

export default [
  {
    path: '/admin/patient/:id',
    // component: Patient,
    component: () => import('@/layouts/Patient/index'),
    meta: {
      title: i18n.t('router.patient.text_1'),
      requireAuth: true,
      isSupportMobile: true
    },
    children: [
      {
        name: 'patientOverview',
        path: '',
        component: () => import('@/pages/Patient/Overview'),
        meta: {
          title: i18n.t('router.patient.text_1'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientRecord',
        path: 'record',
        // component: Summary,
        component: () => import('@/pages/Patient/Record'),
        meta: {
          title: i18n.t('router.patient.text_1'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientReport',
        path: 'report',
        component: () => import('@/pages/Patient/Report'),
        meta: {
          title: i18n.t('router.patient.text_1'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
    ]
  },
  
]
